import React from "react"

function SuggestList({ name, values }) {
    const valuesList = values.map(
        suggestion => <option key={suggestion} value={suggestion} 
    />)
    return <>
        <datalist id={name}>
            {valuesList}
        </datalist>
    </>
}

export default SuggestList